import { DocumentWorkflowTemplateType, SignatureType } from '@dealstack/shared/lib/generated';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import type { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

type MipManageT = TranslateFunction<I18Namespaces.MIP_MANAGE>;
type CommonUiT = TranslateFunction<I18Namespaces.COMMON_UI>;

export const describeSignature = (
	t: MipManageT,
	{ type, signatureType }: { type: DocumentWorkflowTemplateType; signatureType: SignatureType }
): string => {
	if (type === DocumentWorkflowTemplateType.READ_ONLY) {
		return t('send_documents.signature.not_required');
	}
	const signatureMethodLabel: Record<SignatureType, string> = {
		[SignatureType.ELECTRONIC]: t('send_documents.signature.electronic'),
		[SignatureType.WET_INK]: t('send_documents.signature.wet_ink'),
		[SignatureType.REVIEW]: t('send_documents.signature.not_required'),
	};
	return signatureMethodLabel[signatureType];
};

export const describeIndividualSchedule = (
	t: CommonUiT,
	{ individualScheduleRequired }: { individualScheduleRequired: boolean }
): string => (individualScheduleRequired ? t('common_answers.yes') : t('common_answers.no'));

/** Whether this document has ever been issued, from the live-workflow count already on the row. */
export const describeAlreadySent = (
	t: CommonUiT,
	{ issuedDocumentCount }: { issuedDocumentCount: number }
): string => (issuedDocumentCount > 0 ? t('common_answers.yes') : t('common_answers.no'));
